import {SpaceProto} from "../space-proto"
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const"
import MainMenu_Chats from "../../../../layout/menu/sections/chats/menu-chats"
import Navigation_ButtonChats from "../../../../layout/navigation/buttons/chats"
import Chat from "../../chat/chat/chat"
import openChat from "../../../../layout/navigation/actions/open-chat"
import {UIType} from "../../../../layout/ui/@const"
import {featureAccess} from "../../../gd/access-control/feature-access/feature-access"
import {Feature} from "../../../gd/access-control/feature-access/const"


export class SpaceChats extends SpaceProto {

    constructor() {
        super(NavigationSectionType.CHATS)

        this.defaultPosition    = NavigationButtonPosition.MORE

        this.title              = "Chats"
        this.svgIcon            = 'isvg-chat'

        switch (gd.ui.type) {
            case UIType.ASANA:
                this.positions = [NavigationButtonPosition.BOTTOM]
                break

            default:
                break
        }

    }

    onClick = () => {

        if (!featureAccess(Feature.CHAT)) {
            gd.modals.other.upgrade(Feature.CHAT)
            return
        }

        openChat(this.navigation)
    }

    get position() : NavigationButtonPosition {

        if (gd.ui.type === UIType.ASANA) {
            return NavigationButtonPosition.BOTTOM
            // return NavigationButtonPosition.STATIC
        }

        let position : NavigationButtonPosition = _.get(gd.user.settings.navigation.buttonPositions, this.id, this.defaultPosition)

        // defualt / fallback
        if (!this.positions.includes(position)) {
            position = this.defaultPosition
        }

        // so so ... I think we need counter for "MORE" button ....
        // new messages ? -> default !
        if (gd.session.counters.getChatNewMessagesCount()>0) {
            if (position === NavigationButtonPosition.MORE) {
                position = NavigationButtonPosition.TOP
            }
        }

        return position
    }

    set position(position : NavigationButtonPosition) {
        super.position = position
    }

    get enabled():boolean {
        return gd.ac.components.hasAccess('chat')
    }

    get navigationStructureConfig() {
        return {
            id                  : this.id,
            name                : "Chats",
            icon                : "i5-nav-chat",
            hint                : "Chats & Discussions",
            keyboardShortcut    : 'C',
            type                : NavigationSectionType.CHATS,
            menuComponent       : MainMenu_Chats,
            renderComponent     : Navigation_ButtonChats,
            onClick             : this.onClick,
            position            : this.position
        }

    }

    search(keyword: string): Chat[] {
        return gd.session.chats.search(keyword)
    }

}
